import type { SubSectionTabsProps } from './types';

export function SubSectionTabs({
    subSections,
    activeSubSection,
    onSubSectionClick,
}: SubSectionTabsProps) {
    return (
        <div className="bg-white border-b shadow-sm">
            <div className="overflow-x-auto scrollbar-hide">
                <div className="flex gap-4 px-4 py-3 min-w-max border-b border-gray-200">
                    {/* "Tous" option - always first */}
                    <button
                        onClick={() => onSubSectionClick(null)}
                        className={`flex-shrink-0 px-4 py-2 font-medium text-sm transition-all whitespace-nowrap relative ${
                            activeSubSection === null
                                ? 'text-orange-600'
                                : 'text-gray-600 hover:text-gray-900'
                        }`}
                    >
                        Tous
                        {activeSubSection === null && (
                            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-600" />
                        )}
                    </button>
                    {subSections.map((subSection) => {
                        const capitalizedSubSection = subSection.charAt(0).toUpperCase() + subSection.slice(1);
                        return (
                            <button
                                key={subSection}
                                onClick={() => onSubSectionClick(subSection)}
                                className={`flex-shrink-0 px-4 py-2 font-medium text-sm transition-all whitespace-nowrap relative ${
                                    activeSubSection === subSection
                                        ? 'text-orange-600'
                                        : 'text-gray-600 hover:text-gray-900'
                                }`}
                            >
                                {capitalizedSubSection}
                                {activeSubSection === subSection && (
                                    <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-600" />
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
